import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { QuestionnaireCTA, UpsellNote } from "@/pages/MiniPlanPage";
import { Button } from "@/components/ui/button";

export const PaymentCancel = () => (
  <div className="relative z-10 min-h-screen flex items-center justify-center px-6">
    <div className="max-w-md text-center" data-testid="payment-cancel">
      <XCircle className="h-12 w-12 text-muted-foreground mx-auto" />
      <h1 className="text-3xl text-navy mt-6">No payment taken.</h1>
      <p className="text-muted-foreground mt-3">You can subscribe whenever you're ready.</p>
      <Button asChild className="mt-8 rounded-full bg-navy text-white"><Link to="/app/membership">Back to membership</Link></Button>
    </div>
  </div>
);

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const [state, setState] = useState("checking");
  const [access, setAccess] = useState(null);
  useEffect(() => { if (state === "paid") api.get("/me/access").then((r) => setAccess(r.data)).catch(() => {}); }, [state]);

  useEffect(() => {
    const id = params.get("session_id");
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${id}`);
        if (data.payment_status === "paid") return setState("paid");
        if (["expired", "failed"].includes(data.status)) return setState("failed");
      } catch { /* keep polling */ }
      if (++tries < 15) timer = setTimeout(poll, 2000); else setState("failed");
    };
    poll();
    return () => clearTimeout(timer);
  }, [params]);

  return (
    <div className="relative z-10 min-h-screen flex items-center justify-center px-6">
      <div className="max-w-md text-center" data-testid={`payment-${state}`}>
        {state === "checking" && <><Loader2 className="h-12 w-12 animate-spin text-pinkb mx-auto" /><h1 className="text-3xl text-navy mt-6">Confirming your payment…</h1></>}
        {state === "paid" && <><CheckCircle2 className="h-12 w-12 text-leaf mx-auto" />{params.get("item") === "question_bolton"
          ? <><h1 className="text-3xl text-navy mt-6">10 extra questions added.</h1><p className="text-muted-foreground mt-3">They're yours to use until the end of this month.</p></>
          : params.get("item") === "mini_plan"
          ? <><h1 className="text-3xl text-navy mt-6">Your Mini Marketing Plan is booked.</h1><p className="text-muted-foreground mt-3">A confirmation email is on its way.</p><QuestionnaireCTA sessionId={params.get("session_id")} />{access && access.mini_plan_price === 99 && <UpsellNote />}</>
          : <><h1 className="text-3xl text-navy mt-6">Welcome, member.</h1><p className="text-muted-foreground mt-3">Your membership is active.</p>{access?.tier === "pro" && <Button asChild className="mt-6 rounded-full bg-pinkb text-white" data-testid="payment-brand-doc-btn"><Link to="/app/brand-foundations">Start your Brand Foundations</Link></Button>}</>}</>}
        {state === "failed" && <><XCircle className="h-12 w-12 text-rose-600 mx-auto" /><h1 className="text-3xl text-navy mt-6">We couldn't confirm that payment.</h1><p className="text-muted-foreground mt-3">If you were charged, it will appear shortly. Otherwise, please try again.</p></>}
        {state !== "checking" && <Button asChild className="mt-8 rounded-full bg-navy text-white" data-testid="payment-continue-btn"><Link to="/app">Go to my dashboard</Link></Button>}
      </div>
    </div>
  );
}
